import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import GEDatePicker from '../GEDatePicker';

const TitleBar = ({ actions, title, showDateRangePicker = false, tab }) => {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static" enableColorOnDark color="default" sx={{ backgroundColor: 'surface.2' }}>
        <Toolbar>
          <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
            <Typography variant="h5">{title}</Typography>
            {showDateRangePicker && <GEDatePicker />}
          </Box>
          <Box>{actions}</Box>
        </Toolbar>
        {tab}
      </AppBar>
    </Box>
  );
};

export default TitleBar;
